module.exports = __webpack_public_path__ + "img/in-preparation.45a8633e.svg";